import { render, staticRenderFns } from "./Couple_product_page.vue?vue&type=template&id=07d43216&"
import script from "./Couple_product_page.vue?vue&type=script&lang=js&"
export * from "./Couple_product_page.vue?vue&type=script&lang=js&"
import style0 from "./Couple_product_page.vue?vue&type=style&index=0&id=07d43216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports